import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class UserDiamondApi {

    static fetchAll() {
        return HTTP.get(config.cutomerContactApi.contact)
            .then(response => response.data);
    }
}